<template>
  <v-container fluid>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <tenant-form />
  </v-container>
</template>

<script>
import TenantForm from './_Form'

export default {
  name: 'DriverMasterCustomLabelEdit',
  components: {
    TenantForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'カスタム表示ラベル', disabled: false, to: '/driver/masters/custom_labels', exact: true },
        { text: 'カスタム表示ラベル編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>
